export class ContactInfo {
    phoneNumber;
    email;
    city;
    street;
    state;
    zipCode;
}

//export default ContactInfo;